import {normalizePhone} from 'goodeggs-formatters';

export default function validatePhone(phoneNumber?: string | null): boolean {
  return /^\+1\d{10}$/.test(normalizePhone(phoneNumber));
}
